// extracted by mini-css-extract-plugin
export default {"container":"CartItemContainer_container__lcPmb"};